<template>
  <a-modal
    title="确定要取消吗?"
    :visible="visible"
    :width="800"
    :confirm-loading="submitLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <div>
      <div style="display: flex;flex-direction:column; overflow: auto;  max-height: 500px;">
        <div :key="item.id" v-for="(item, index) in list">
          <span>{{index + 1 + '：申请人：' + (item.applicant || '无') + '，费用类别：' + item.paymentType + '，金额：' + item.oaAmount + '元' }}</span>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
/* eslint-disable eqeqeq */
import moment from 'moment';
import _ from 'lodash';
import SvgIcUpload from '@/assets/svg/ic-upload.svg';
import PriceAdminService from '../../services/PriceAdminService';
import ProjectManageService from '../../services/ProjectManageService';
import {
  downloadFile
} from '../../utils/tools';
import {
  getCurrentUser,
} from '@/services/user';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    SvgIcUpload,
  },
  props: {
    visible: Boolean, // 是否弹窗可见[true, false]
    list: Array,
  },
  data() {
    return {
      submitLoading: false,
      payTypeList: [],
      monthFormat: 'YYYY-MM',
      formLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 17
        }
      },
      invoiceTrackStatusList: [
        { key: 1, val: '未追踪' },
        { key: 2, val: '部分回票' },
        { key: 3, val: '发票已回' },
      ],
    };
  },

  methods: {
    handleOk() {
      this.$emit('submit');
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
  mounted() {

  },

};
</script>

<style lang="less">

</style>
